<template>
  <div id="app">
    <div v-html="marked(readme)" />
    <vc-style>
    body
    {
      font-family: {{ fontFamily }};
      color: {{ color }};
    }

    blockquote
    {
      padding: 0;
      margin: 0;
    }
    </vc-style>
    <vc-social-bar :title="description" position="right" :services="services" />
  </div>
</template>
<script>
import VcStyle from './components/vc-style'
import VcSocialBar from 'vc-social-bar'
import services from './helpers/vc-social-bar-services'
import 'vc-social-bar/dist/lib/vc-social-bar.min.css'
import readme from '../README.md'
import marked from 'marked'
import { description } from '../package'

export default {
  name: 'app',
  components: {
    VcStyle,
    VcSocialBar
  },
  data () {
    return {
      marked,
      readme,
      services,
      description,
      fontFamily: 'Arial, "Helvetica Neue", Helvetica, sans-serif',
      color: '#303030'
    }
  }
}
</script>



// WEBPACK FOOTER //
// app.vue?0b3a448a